export default "/fonts/vendor/@fontsource/lato/files/lato-latin-400-normal.woff?190b769c7be76a0f0dbfdf9b15eb544d";